import anchorme from 'anchorme'
import {AnchormeItem} from '../types'

export const getStoredLinksFromString = (text: string): AnchormeItem[] => {
    return anchorme.list(text).map((item: AnchormeItem) => ({
        ...item,
        host: item.host?.replace(/^www\./, '')
    }))
}
